import React from 'react';
import { motion } from 'framer-motion';
export function OfertaSection() {
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="oferta-especial" className="px-4 py-8 md:py-12 bg-[#fffde7] overflow-hidden" data-id="element-89">
      <motion.div className="max-w-md mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.15
    }} data-id="element-90">
        {/* Heading */}
        <h2 className="text-[1.6rem] font-black text-center text-[#f57f17] mb-4" data-id="element-91">
          🎉{' '}
          <span className="bg-[#ffeb3b] px-1" data-id="element-92">
            OFERTA ESPECIAL DE LANZAMIENTO
          </span>
        </h2>

        {/* Description */}
        <p className="text-base font-medium text-gray-800 leading-relaxed text-center" data-id="element-93">
          💛 <em data-id="element-94">Educando a nuestros peques</em> es un recurso único para
          estimular el desarrollo temprano de tu hijo/a de forma divertida,
          amorosa y eficaz.
        </p>

        {/* Benefits list */}
        <ul className="text-base text-gray-800 mt-4 space-y-2 leading-relaxed" data-id="element-95">
          <li data-id="element-96">
            ✅{' '}
            <span className="bg-[#ffeb3b] px-1" data-id="element-97">
              Evita la sobreinformación:
            </span>{' '}
            actividades listas para usar
          </li>
          <li data-id="element-98">
            ✅ <span className="bg-[#ffeb3b] px-1" data-id="element-99">Ahorra tiempo:</span> guía
            paso a paso sin complicaciones
          </li>
          <li data-id="element-100">
            ✅ <span className="bg-[#ffeb3b] px-1" data-id="element-101">Crea conexión real:</span>{' '}
            momentos de aprendizaje en casa
          </li>
          <li data-id="element-102">
            ✅{' '}
            <span className="bg-[#ffeb3b] px-1" data-id="element-103">
              Respaldado por +5.600 familias
            </span>{' '}
            que ya lo usan con excelentes resultados
          </li>
        </ul>

        {/* Bonos */}
        <div className="bg-[#fff9c4] p-4 rounded-xl mt-4" data-id="element-104">
          <p className="font-bold text-[1.1rem] mb-2" data-id="element-105">
            🎁 ¡Incluye 2 Bonos Gratis!
          </p>
          <p className="text-base text-gray-800" data-id="element-106">
            <strong data-id="element-107">BONO 1:</strong> Libro para colorear 🖍️
            <br data-id="element-108" />
            <strong data-id="element-109">BONO 2:</strong> Hábitos y rutinas 🛁
          </p>
        </div>

        {/* Product image */}
        <div className="w-full mt-5" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/rtJQDoH3ptkaTXcDeHGUdz/Imagen-de-WhatsApp-2025-04-29-a-las-21.40.32_f620f521-1.jpg" alt="Actividades para la Inteligencia" className="w-full rounded-xl shadow-md" data-id="element-111" />
        </div>

        {/* Pricing */}
        <div className="text-center mt-5" data-id="element-112">
          <p className="text-[0.9rem] text-gray-400 line-through" data-id="element-113">
            💸 Precio regular: $69.990 ARS
          </p>
          <span className="inline-block mt-2 text-white font-bold text-sm px-3 py-1.5 rounded-lg" style={{
          backgroundColor: '#d50000'
        }} data-id="element-114">
            🔥 75% DE DESCUENTO
          </span>
          <p className="mt-3 text-base text-gray-800" data-id="element-115">
            👉 Hoy:{' '}
            <span className="text-[1.5rem] text-[#2e7d32] font-bold" style={{
            fontSize: "32px"
          }} data-id="element-116">
              $16.990 ARS
            </span>
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-117">
            Pago único • Acceso inmediato
          </p>
        </div>

        {/* CTA */}
        <a href="https://infoliar.com/cart/56690835489100:1" className="block w-full mt-5 text-white font-bold text-base py-4 rounded-xl text-center" style={{
        backgroundColor: '#2e7d32',
        boxShadow: '0 4px 16px rgba(46, 125, 50, 0.4)'
      }} data-id="element-118">
          COMPLETAR COMPRA — $16.990 ARS
        </a>

        {/* Info */}
        <p className="text-[0.9rem] text-gray-500 text-center mt-3 leading-relaxed" data-id="element-119">
          📥 Descarga inmediata. Solo necesitas tu celular o computadora.
          <br data-id="element-120" />
          🛡️ Garantía de satisfacción de 30 días.
        </p>
      </motion.div>
    </section>;
}